if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        try {
             this.form.querySelector('[name=id]').disabled = false;
            this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
            this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
            this.submitButton = this.querySelector('[type="submit"]');
        } catch (error) {
          
        }
     
      

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
         const cquantity = $('.price-per-item__container .quantity__input').val();
        $('.input-type-form').val(cquantity);
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            fetch('/cart.json').then(t=>t.json()).then(r=>{console.log(r, '<<<r')})
            console.log(response)
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.querySelector('span').classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              if(window.cartDrawer.type == 'drawer'){
                console.log('show custom cart drawer here');
                window.refreshCart();
                window.onCartUpadate();
              }else{
                window.location = window.routes.cart_url;
              }
              return;
            }

            
            
            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-form', productVariantId: formData.get('id'), cartData: response });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading-overlay__spinner').classList.add('hidden');
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}

$(document).on('change','.product-form__input .list-swatchs input', function(){
  setTimeout(function(){
    const cvprice = $('.vqp-price-wrapper span.price-item.price-item--regular').text();
    const hasProductAvail = $('button.product-form__submit').prop('disabled');
    $('.satc-wrapper .satc-price').text(cvprice);
    if(hasProductAvail){
        $('.satc-product-form__submit').prop('disabled',true);
        $('.satc-product-form__submit span.sold-out').removeClass('hide');
       $('.satc-product-form__submit span.available').addClass('hide');
    }else{
        $('.satc-product-form__submit').prop('disabled',false);
        $('.satc-product-form__submit span.available').removeClass('hide');
        $('.satc-product-form__submit span.sold-out').addClass('hide');
    }
  },1000);
});
$(document).on('click','button.satc-product-form__submit',function(){
    $('.product-form__buttons button.product-form__submit').click();
    $(this).prop('disabled',true);
    $(this).find('.loading-overlay__spinner').removeClass('hidden');
    $(this).find('.available').addClass('hide');
    setTimeout(function(){
      $('button.satc-product-form__submit').find('.loading-overlay__spinner').addClass('hidden');
      $('button.satc-product-form__submit').find('.available').removeClass('hide');
      $('button.satc-product-form__submit').prop('disabled',false);
    },2000);
});
if($(window).width() < 768) {
$('.tabs--product .slider__slides').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    infinite: false,
    dots: true,
    arrows: false
});
}
